import './Banner.css'

type BannerProps = {
    image: string;
    caption: string;
};

export default function Banner({ image, caption }: BannerProps){
    return(
        <div className='banner'>
            <div className="banner-caption">{caption}</div>
        </div>
    )
}